module.exports = __webpack_public_path__ + "assets/images/inapp-onsite-layout-img.svg";